import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import * as myGlobals from "../../modelos/globales.modelo";
import * as DepartamentoArea from "../../modelos/dtoarea.modelo";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAccordion } from "@angular/material/expansion";
import { ApiAppService } from "./../../servicios/apiapp.service";

// Declaramos las variables para jQuery
declare let jquery: any;
declare let $: any;

@Component({
    selector: "app-info-areas",
    templateUrl: "infoareas.component.html",
    styleUrls: ["infoareas.component.css"],
    providers: [ApiAppService],
    standalone: false
})
export class InfoAreasComponent implements OnInit {
  public aDatos: DepartamentoArea.cDeparta[];

  @ViewChild("acordeon", { static: true }) oAcordeon: MatAccordion;

  public panelOpenState = true;

  constructor(
    public oRouter: Router,
    public _ApiAppService: ApiAppService,
  ) {}

  ngOnInit() {
    $(".capa-cita").addClass("visible");

    // Cargamos todos los departamentos y áreas de atención al público

    this.CargarDepartamentosAreasHorario();
  }

  // Carga de todos los departamentos y áreas de atención
  CargarDepartamentosAreasHorario(): void {
    let DATA_DTO_AREA_HORARIO: DepartamentoArea.IDtoAreaHorario[];

    myGlobals.Mensaje(
      myGlobals.eTipoMensaje.BarraProgreso,
      "",
      "Cargando departamentos y áreas, espere ...",
      "",
    );

    // Comprobamos si existe el solicitante y además tiene citas pendientes

    this._ApiAppService.ObtenerTodosLosDepartamentoHorarioAreas().subscribe(
      (data) => {
        if (myGlobals.isNullUndefined(data) || data.length === 0) {
          myGlobals.Mensaje(
            myGlobals.eTipoMensaje.Advertencia,
            "",
            "No hay definido ningún departamento en el cliente.",
            "",
          );
        } else {
          DATA_DTO_AREA_HORARIO = data;

          this.aDatos = [];
          for (let i = 0; i <= DATA_DTO_AREA_HORARIO.length - 1; i++) {
            const oDeparta: DepartamentoArea.cDeparta =
              new DepartamentoArea.cDeparta();
            oDeparta.DEPARTAMENTO = DATA_DTO_AREA_HORARIO[i].DEPARTAMENTO;
            oDeparta.HORARIO = this.FormateaInfoHorario(
              DATA_DTO_AREA_HORARIO[i].HORARIO,
            );

            const aAreas = new Array<DepartamentoArea.cArea>();
            for (
              let n = 0;
              n <= DATA_DTO_AREA_HORARIO[i].AREAS.length - 1;
              n++
            ) {
              const oArea: DepartamentoArea.cArea =
                new DepartamentoArea.cArea();
              oArea.id_area = DATA_DTO_AREA_HORARIO[i].AREAS[n].id_area;
              oArea.AREA = DATA_DTO_AREA_HORARIO[i].AREAS[n].AREA;
              oArea.INFO = DATA_DTO_AREA_HORARIO[i].AREAS[n].txtinfoweb;
              oArea.CARENCIA =
                "Carencia entre cita " +
                DATA_DTO_AREA_HORARIO[i].AREAS[n].minutos5xcita * 5 +
                " minutos";
              aAreas.push(oArea);
            }
            oDeparta.AREAS = aAreas;

            this.aDatos.push(oDeparta);
          }
          myGlobals.Mensaje(myGlobals.eTipoMensaje.Close, "", "", "");
        }
      },
      (err) => {
        myGlobals.CapturaMensajeHTTP(err, true);
      },
    );
  }

  // Devuelve formateado
  FormateaInfoHorario(aHorario: DepartamentoArea.IHorarioDto[]): string[] {
    const aResultado = new Array<string>();
    let iDiaSemanaAnt = -1;
    let sHorario = "";

    if (!myGlobals.isNullUndefined(aHorario) && aHorario.length > 0) {
      for (let i = 0; i <= aHorario.length - 1; i++) {
        if (iDiaSemanaAnt > 0 && aHorario[i].dia_semana !== iDiaSemanaAnt) {
          sHorario = myGlobals.aDiaSemana[iDiaSemanaAnt - 1] + ": " + sHorario;
          aResultado.push(sHorario);
          sHorario =
            aHorario[i].hora_inicio.substring(0, 5) +
            " - " +
            aHorario[i].hora_fin.substring(0, 5);
        } else {
          if (sHorario !== "") {
            sHorario = sHorario + ", ";
          }
          sHorario =
            sHorario +
            aHorario[i].hora_inicio.substring(0, 5) +
            " - " +
            aHorario[i].hora_fin.substring(0, 5);
        }
        iDiaSemanaAnt = aHorario[i].dia_semana;
      }

      sHorario = myGlobals.aDiaSemana[iDiaSemanaAnt - 1] + ": " + sHorario;
      aResultado.push(sHorario);

      return aResultado;
    }

    return ["No hay horarios disponibles"];
  }
}
